// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import moment from 'moment'
import zenScroll from 'zenscroll'

Vue.use(VueI18n);

Vue.config.productionTip = false;

zenScroll.setup(null, 85);

const messages = {
  "de-AT": require('@/lang/de.json'),
  "en-GB": require('@/lang/en.json')
}

const i18n = new VueI18n({
  locale: 'de-AT',
  fallbackLocale: 'de-AT',
  messages,
  sync: true
})

/* eslint-disable no-new */
new Vue({
    i18n,
    el: '#app',
    router,
    template: '<App/>',
    components: {App},
    mounted() {
      this.switchLanguage(window.location.pathname.substring(1, 3));
      setTimeout(this.scroll, 2000);
    },
    watch: {
      $route (to) {
        this.switchLanguage(to.path.substring(1, 3));
        this.scroll();
      }
    },
    mixins: [
      {
        methods:  {
          switchLanguage(shortLocal) {
            let lang = "de-AT";
            switch (shortLocal) {
              case 'de':
                lang = 'de-AT';
                break;

              case 'en':
                lang = 'en-GB';
                break;
            }

            this.$i18n.locale = lang;
            moment.locale(this.$i18n.locale);
            document.title = this.$i18n.t('main.title');
            document.querySelector('meta[property="og:title"]').setAttribute('content', this.$i18n.t('main.title'));
            document.querySelector('meta[property="og:locale"]').setAttribute('content', lang.replace('-', '_'));
            document.querySelector('meta[name="keywords"]').setAttribute('content', this.$i18n.t('meta.keywords'));
          },
          scroll() {
            let path = window.location.pathname;
            let route = router.resolve(path);
            let name = "";
            let selector = "";

            if (route) {
              name = route.route.name;
            }

            if (!name) {
              return;
            }

            if (name.indexOf('Main') !== -1) {
              zenScroll.toY(0);
            }
            else if (name.indexOf('Ticketbuchung') !== -1) {
              zenScroll.toY(0, 0);
            }
            else {
              if (name.indexOf('Infos') !== -1) {
                selector = '#infos';
              }
              else if (name.indexOf('Details') !== -1) {
                selector = '#details';
              }
              else if (name.indexOf('Termine') !== -1 || name.indexOf('Tickets') !== -1) {
                selector = '#termine';
              }

              if (selector !== "") {
                let element = document.querySelector(selector);
                if (element) {
                  zenScroll.to(element);
                }
              }
            }
          }
        }
      }
    ]
});



// WEBPACK FOOTER //
// ./src/main.js